var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommersialPropertyLoan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 66.42C67 68.398 54.912 70 39.999 70 25.086 70 13 68.399 13 66.42c0-.467.676-.915 1.903-1.323v1.11H49.7v-3.13c10.12.517 17.3 1.818 17.3 3.343z",
    fill: "#CAEEE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11a2 2 0 012-2h31a2 2 0 012 2v54H15V11z",
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.894 30.04L50 23.013V65h15V31.85c0-.766-.428-1.466-1.106-1.81z",
    fill: "#E1F8F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22v7.082m-12-6.07l13.894 7.029A2.026 2.026 0 0165 31.85V65H50V23.012z",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.75,
    y: 14.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.75,
    y: 14.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    fill: "#E1F8F1",
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.75,
    y: 14.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.75,
    y: 24.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    fill: "#E1F8F1",
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.75,
    y: 24.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39.75,
    y: 24.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    fill: "#E1F8F1",
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19.75,
    y: 34.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 29.75,
    y: 34.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    fill: "#E1F8F1",
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 39.75,
    y: 34.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 19.75,
    y: 44.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    fill: "#E1F8F1",
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 29.75,
    y: 44.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 39.75,
    y: 44.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    fill: "#E1F8F1",
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 19.75,
    y: 54.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 29.75,
    y: 54.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    fill: "#E1F8F1",
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 39.75,
    y: 54.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 53.75,
    y: 31.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 53.75,
    y: 41.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    fill: "#fff",
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 53.75,
    y: 51.75,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61h6",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default SvgCommersialPropertyLoan;